function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.012 26c.919 7.256-7.244 18.139-13.513 8.923 2.642 9.216 12.595 10.123 16.589.044.545 5.544 4.168 15.52-8.426 16.978.808 3.077 14.408 1.984 18.048-14.341 3.64 16.325 17.239 17.418 18.048 14.34-12.599-1.456-9.045-11.32-8.426-16.977 3.983 10.079 13.947 9.172 16.589-.044-6.27 9.216-14.409-1.667-13.513-8.923C44.036 7.861 34.723 3.326 27.711 3.326S11.386 7.861 15.014 26z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 24.177,
  cy: 13.689,
  rx: 1.5,
  ry: 3.5
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(90)",
  cx: 13.689,
  cy: -24.677,
  rx: 1,
  ry: 0.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 30.177,
  cy: 13.689,
  rx: 1.5,
  ry: 3.5
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(90)",
  cx: 13.689,
  cy: -30.677,
  rx: 1,
  ry: 0.5
})), /*#__PURE__*/React.createElement("path", {
  d: "M21 19c3.662 5.32 10 5 13 0",
  strokeWidth: 1.002
}));

var SvgOctopus = function SvgOctopus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOctopus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Octopus.cfe9792d.svg";
export { ForwardRef as ReactComponent };